import { Config } from '../../config'

export const cleanroomConfig: Config = {
  partner: 'cleanroom',
  catalog: 'partner',
  displayName: 'Cleanroom Connection',
  accentColor: '#00a4ec',
  host: 'chairs.cleanroomsupplies.com',
}
